export function getLineItemEditUris(selectedItems) {
    if (!selectedItems || !selectedItems.length) {
        return [];
    }

    var uris = [];
    for (var i = 0; i < selectedItems.length; i++) {
        var uri = selectedItems[i] && selectedItems[i].LineItemEditUri;
        if (!uri) {
            return null;
        }
        uris.push(uri);
    }

    return uris;
}
